var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.bell)?_c('div',{staticClass:"bell",attrs:{"id":_vm.bell.day_schedule_item_id}},[_vm._v("\n     "+_vm._s(_vm.formatted_time)+" - "+_vm._s(_vm.bell.description)+"\n")]):_c('div',{staticClass:"bell"})}
var staticRenderFns = []

export { render, staticRenderFns }